<template lang="pug">
.v-filter.filter
	v-loader(:loading="loading")
	.filter__top(v-if="showTop")
		.filter__header
			button.filter__close(type="button" @click="close")
				v-svg-icon.filter__close-icon(icon="close")
			.filter__title Параметры
			button.filter__reset(type="button" @click="resetAll") Сбросить
	template(v-if="localFilters")
		template(v-for="(filter, filterIndex) in localFilters" :key="filterIndex")
			template(v-if="onlyTabs ? filter.type === 'tabs' : filter.type !== 'tabs'")
				.filter__item.flc(:class="{'filter__item--disabled': filter.disabled}" :data-filter-id="filter.type === 'links' ? null : filter.id + ''")
					v-field(:field="filter"
							:is-in-filter="true"
							v-model="filter.value"
							@update:model-value="filterChange")
</template>

<script>
export default {
	props: {
		links: {
			type: Array,
			default: null
		},

		filters: {
			type: Array,
			default: null
		},

		view: {
			type: String,
			default: 'regular'
		},

		onlyTabs: {
			type: Boolean,
			default: false
		},

		showTop: {
			type: Boolean,
			default: false
		},

		loading: {
			type: Boolean,
			default: false
		}
	},

	emits: [
		'filter-changed',
		'filter-updated',
		'filter-closed'
	],

	data() {
		return {
			localFilters: [],
			filterDebounceTimeout: null,
			lastChangedFilterId: null
		};
	},

	computed: {
		changedFilters() {
			let result = [];
			this.localFilters.forEach((filter) => {
				if (this.isFilterChanged(filter)) {
					result.push(filter);
				}
			});
			return result;
		}
	},

	watch: {
		filters() {
			this.applyNewFilters();
		}
	},

	created() {
		this.applyNewFilters();
	},

	methods: {
		close() {
			this.$emit('filter-closed');
		},

		isFilterChanged(filter) {
			if (typeof filter.value == 'number' ||
					(filter.value && filter.value.length && filter.value.length > 0) ||
					(filter.type === 'range') ||
					(filter.type === 'range-slider')) {
				return true;
			}
			return false;
		},

		isFilterBlocked(filterId) {
			return this.lastChangedFilterId && this.lastChangedFilterId !== filterId;
		},

		applyNewFilters() {
			let tmpFilters = [];
			this.filters.forEach((filter) => {
				let oldFilter = this.localFilters.find((item) => item.id === filter.id);
				filter.open = oldFilter ? oldFilter.open : !!filter.open;
				tmpFilters.push(filter);
			});
			this.localFilters = JSON.parse(JSON.stringify(tmpFilters));
			this.$emit('filter-updated', this.createValue(), this.changedFilters);
		},

		resetFilter(options) {
			let filter = this.localFilters.find((filter) => filter.id === options.id);
			if (!filter) {
				return;
			}
			if (filter.type === 'range' || filter.type === 'range-slider') {
				filter.value.min = '';
				filter.value.max = '';
			} else {
				if (options.value && Array.isArray(filter.value)) {
					filter.value.splice(filter.value.indexOf(options.value), 1);
				} else {
					filter.value = [];
				}
			}
			if (!options.silent) {
				this.filterChange(filter, null, true);
			}
		},

		resetAll() {
			this.localFilters.forEach((filter) => {
				this.resetFilter({id: filter.id, silent: true});
			});
			this.filterChange(null, null, true);
		},

		createValue(uncheckedFilter) {
			let result = {};
			this.changedFilters.forEach((filter) => {
				if (filter.type === 'links') {
					result[filter.id] = {value: filter.value, type: 'radio-list'};
				} else {
					if (uncheckedFilter && filter.id === uncheckedFilter.id) {
						result[filter.id] = {type: filter.type, value: filter.value, uncheckedValue: uncheckedFilter.uncheckedValue};
					} else {
						result[filter.id] = {type: filter.type, value: filter.value};
					}
				}
			});
			return result;
		},

		filterChange(filter, uncheckedFilter, submit = false) {
			if (filter) {
				this.lastChangedFilterId = filter.id;
			}
			clearTimeout(this.filterDebounceTimeout);
			let timout = 0;
			this.filterDebounceTimeout = setTimeout(() => {
				this.lastChangedFilterId = null;
				this.$emit('filter-changed', this.createValue(uncheckedFilter), this.changedFilters, submit ?
					submit : (filter ? filter.autosubmit : false));
			}, timout);
		}
	}
};
</script>